module.exports = __webpack_public_path__ + "img/group.711d6e54.png";